import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme/theme';
import { CatalogContainer } from './components/CatalogContainer';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CatalogContainer />
    </ThemeProvider>
  );
};

export default App;
